// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const onlinearabiaColors: ColorType = {
  ...colorPalette,
  primary: '#006C35',
  secondary: '#009A4C',
  greenSuccess: '#006C35',
}

export const lightTheme = {
  colors: onlinearabiaColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: onlinearabiaColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: onlinearabiaColors.dark,
    secondary: onlinearabiaColors.grayText,
    disabled: onlinearabiaColors.dark,
    link: onlinearabiaColors.dark,
    hint: onlinearabiaColors.dark,
    highlight: onlinearabiaColors.primary,
    gray: onlinearabiaColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: onlinearabiaColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: onlinearabiaColors.dark,
    color: onlinearabiaColors.dark,
    border: onlinearabiaColors.primary,
    scrollbarThumb: onlinearabiaColors.primary,
    programTitle: onlinearabiaColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: onlinearabiaColors.dark,
        selected: onlinearabiaColors.dark,
        progress: rgba(onlinearabiaColors.primary, 0.3),
        past: rgba(onlinearabiaColors.primary, 0.3),
        pastSelected: onlinearabiaColors.dark,
        pastHover: onlinearabiaColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(onlinearabiaColors.primary, 0.1),
      },
      text: {
        empty: onlinearabiaColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: onlinearabiaColors.dark,
    subTitle: onlinearabiaColors.grayText,
    bg: onlinearabiaColors.dark,
    number: onlinearabiaColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
